import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Badge from "../Badge/badge";

// COMPLEX DATE CALCS
import {
  dateParse,
  formatDate,
  calculateEndDateFromWeeks,
  countMondays,
  getWeekDifference,
} from "utils/date";
import {
  getAttendance,
  setEdit,
  selectStudent,
  setAttendanceDate,
  setAttendanceStatus,
  setSelectedId,
} from "../../services/journalSlice";

const JournalContent = () => {
  const dispatch = useDispatch();

  const statefulSelector = useSelector(({ JournalApp }) => JournalApp.journal);
  const studentList = statefulSelector.studentData.course;

  useEffect(() => {
    if (statefulSelector.selectedClass !== null) dispatch(getAttendance());
  }, [dispatch, statefulSelector.selectedClass, statefulSelector.edit]);

  let calculated;
  let columnData = ["№", "Нэр"];
  if (statefulSelector.selectedClass) {
    let dateCount = countMondays(
      statefulSelector.teacherData.start,
      statefulSelector.teacherData.end
    );
    for (let index = 1; index <= dateCount; index++) {
      columnData.push(index);
    }
    calculated = dateCount;
  }

  return (
    <>
      {statefulSelector.selectedClass !== null && (
        <div className={"mt-4 h-full w-full overflow-x-scroll p-4"}>
          {studentList.length !== 0 ? (
            <table
              className="mb-4  h-max w-full border"
              variant="simple"
              color="gray-500"
              mb="24px"
            >
              <thead>
                <tr>
                  {columnData.map((item, index) => {
                    let dateString = calculateEndDateFromWeeks(
                      statefulSelector.teacherData.start,
                      item - 1
                    );
                    return (
                      <th
                        className="border-b border-l border-gray-200 pb-[10px]  text-center  dark:!border-navy-700 "
                        key={"journal-header" + index}
                      >
                        <div className=" text-center font-bold text-gray-600">
                          {index > 1 ? formatDate(dateString).slice(5) : item}
                        </div>
                      </th>
                    );
                  })}
                  <th className="border-b border-gray-200 pb-[10px]  text-center dark:!border-navy-700">
                    <Badge status={1} />
                  </th>
                  <th className="border-b border-gray-200 pb-[10px]  text-center  dark:!border-navy-700 ">
                    <Badge status={2} />
                  </th>
                  <th className="border-b border-gray-200 pb-[10px]  text-center  dark:!border-navy-700 ">
                    <Badge status={3} />
                  </th>
                  <th className="border-b border-gray-200 pb-[10px]  text-center  dark:!border-navy-700 ">
                    <Badge status={4} />
                  </th>
                </tr>
              </thead>
              <tbody>
                {Object.values(studentList).map((value, index) => {
                  let array = value.student_to_attendance_record;
                  let hashmap = [];
                  hashmap.length = calculated;

                  for (let weekDay = 0; weekDay < hashmap.length; weekDay++) {
                    hashmap[weekDay] = {
                      id: -1,
                      status: "",
                      attendanceDate: formatDate(
                        calculateEndDateFromWeeks(
                          statefulSelector.teacherData.start,
                          weekDay
                        )
                      ),
                    };
                  }

                  array.forEach((value) => {
                    let dayof = dateParse(value.attendanceDate);
                    hashmap[
                      getWeekDifference(
                        statefulSelector.teacherData.start,
                        dayof
                      )
                    ] = value;
                  });

                  return (
                    <tr key={"row-data-" + index}>
                      <td className="border-b p-1 text-center  font-bold text-gray-700 dark:!border-navy-800">
                        {index + 1}
                      </td>
                      <td className="border-b">
                        {value.firstname + " " + value.lastname}
                      </td>
                      {hashmap.map((data, weekCount) => {
                        return (
                          <td
                            key={"attendance-" + weekCount}
                            className="border-l border-b border-gray-200 p-1"
                            onClick={() => {
                              dispatch(selectStudent(index));
                              dispatch(setAttendanceDate(data.attendanceDate));
                              dispatch(setAttendanceStatus(data.status));
                              dispatch(setSelectedId(data.id));
                              dispatch(setEdit(true));
                            }}
                          >
                            <span
                              className="full-w flex"
                              style={{
                                width: "100%",
                                display: "flex",
                                justifyContent: "center",
                              }}
                            >
                              <Badge status={data.status} />
                            </span>
                          </td>
                        );
                      })}
                      <td className="full-w flex border-l border-b border-gray-200 p-1">
                        <span
                          className="full-w flex"
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          {hashmap.filter((item) => item.status === 1).length}
                        </span>
                      </td>
                      <td className="border-l border-b border-gray-200 p-1">
                        <span
                          className="full-w flex"
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          {hashmap.filter((item) => item.status === 2).length}
                        </span>
                      </td>
                      <td className="border-l border-b border-gray-200 p-1">
                        <span
                          className="full-w flex"
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          {hashmap.filter((item) => item.status === 3).length}
                        </span>
                      </td>
                      <td className="border-l border-b border-gray-200 p-1">
                        <span
                          className="full-w flex"
                          style={{
                            width: "100%",
                            display: "flex",
                            justifyContent: "center",
                          }}
                        >
                          {hashmap.filter((item) => item.status === 4).length}
                        </span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <div
              className="w-full text-center font-poppins font-bold"
              style={{
                height: "300px",
                alignItems: "center",
                justifyContent: "center",
                display: "flex",
              }}
            >
              Хоосон байна
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default JournalContent;
